import axiosPost from "../axiosPost";

export const SFVoucherDel = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFVoucherDel",
        params: {
            SFVoucherId: params?.SFVoucherId
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
